var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.333333, 2.666667)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0.000666666667 L1.33333333,0.000666666667 C0.598,0.000666666667 0,0.599333333 0,1.334 L0,3.334 L13.3333333,3.334 L13.3333333,1.334 C13.3333333,0.599333333 12.736,0.000666666667 12,0.000666666667 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666666667,4.00066667 L0.666666667,10.0006667 C0.666666667,10.736 1.26466667,11.334 2,11.334 L11.3333333,11.334 C12.0693333,11.334 12.6666667,10.736 12.6666667,10.0006667 L12.6666667,4.00066667 L0.666666667,4.00066667 Z M8.66666667,6.66733333 L4.66666667,6.66733333 L4.66666667,5.334 L8.66666667,5.334 L8.66666667,6.66733333 Z",
    id: "Shape"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.79dabc5e43d1dd1790e15dbf2b3ed581.svg";
export { ForwardRef as ReactComponent };